import React, { useState } from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function Kin() {
  useReveal();
  const { c } = useSite();
  const { kin } = c;
  const [active, setActive] = useState(0);
  const p = kin.people[active];
  return (
    <section id="kin" className="bg-ink py-28 sm:py-40">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-7">
            <span className="eyebrow">{kin.label}</span>
          </div>
          <h2 className="font-display text-4xl sm:text-6xl font-light leading-[1.02] text-parchment">{kin.title}</h2>
          <p className="mt-5 text-lg leading-relaxed text-parchment/60 font-light">{kin.intro}</p>
        </div>

        <div className="grid lg:grid-cols-5 gap-10 mt-16">
          {/* selector */}
          <div className="lg:col-span-2 flex flex-col">
            {kin.people.map((person, i) => (
              <button
                key={person.id}
                onClick={() => setActive(i)}
                className={`text-left border-t border-[var(--c-border)] py-6 group transition-colors duration-300 ${
                  active === i ? "" : "opacity-55 hover:opacity-90"
                }`}
              >
                <div className="flex items-center gap-4">
                  <span className={`font-display text-2xl w-8 ${active === i ? "text-gold" : "text-stone2"}`}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <span className="font-display text-2xl sm:text-3xl font-medium text-parchment block leading-tight">
                      {person.name}
                    </span>
                    <span className="font-label text-[0.66rem] uppercase tracking-[0.2em] text-gold">
                      {person.epithet} · {person.era}
                    </span>
                  </div>
                </div>
              </button>
            ))}
            <span className="border-t border-[var(--c-border)]" />
          </div>

          {/* detail */}
          <div className="lg:col-span-3">
            <div key={p.id} className="reveal in-view">
              <figure className="img-zoom border border-[var(--c-border)] bg-ink2">
                <img src={p.image} alt={p.name} className="w-full h-[420px] object-cover object-top grayscale-[0.35]" />
                <figcaption className="px-6 py-5 border-t border-[var(--c-border)]">
                  <span className="font-label text-[0.68rem] uppercase tracking-[0.24em] text-gold">{p.place}</span>
                  <h3 className="font-display text-3xl sm:text-4xl font-light text-parchment mt-1 leading-tight">{p.name}</h3>
                  <p className="font-display italic text-lg text-parchment/80">{p.epithet}</p>
                </figcaption>
              </figure>
              <p className="mt-7 text-xl leading-relaxed text-parchment/70 font-light">{p.text}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
